// src/api/api.js
import axiosInstance from "./axiosInstance";

// 学管获取IM的token
export const getImToken = async (token) => {
  try {
    const data = await axiosInstance.post("/staff-get-im-token", token);
    return data;
  } catch (error) {
    throw error;
  }
};
//导出学生列表
export const exportStudentList = async (token) => {
  try {
    const data = await axiosInstance.post("/student/list-export", token);
    return data;
  } catch (error) {
    throw error;
  }
};
//导出学生学员记录
export const exportStudentStudyRecord = async (token) => {
  try {
    const data = await axiosInstance.post("/student/study-record-export", token);
    return data;
  } catch (error) {
    throw error;
  }
};
//数据中心学习记录导出
export const studyRecordExport = async (token) => {
  try {
    const data = await axiosInstance.post("/study-record-export", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const getLdktRoom = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/get-ldkt-room", token);
    return data;
  } catch (error) {
    throw error;
  }
};
// 查询所有的title
export const listAllTitle = async (token) => {
  try {
    const data = await axiosInstance.post("/student/list-all-title", token);
    return data;
  } catch (error) {
    throw error;
  }
};
// 查询配置的的title（用于表单展示）
export const istStaffTitle = async (token) => {
  try {
    const data = await axiosInstance.post("/student/ist-staff-title", token);
    return data;
  } catch (error) {
    throw error;
  }
};
// 配置标题确认 参数例如：[{"label": "student_no","title": "学号"},{"label": "student_name","title": "学生姓名"}]
export const listUpdateStaffTitle = async (token) => {
  try {
    const data = await axiosInstance.post("/student/list-update-staff-title", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const getStudentWeekList = async (token) => {
  try {
    const data = await axiosInstance.post("/student/get-student-week-list", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const getTeacherWeekList = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/get-teacher-week-list", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const getTheFilterList = async (token) => {
  try {
    const data = await axiosInstance.post("/student/class-all-selected", token);
    return data;
  } catch (error) {
    throw error;
  }
}
export const studentGetStudentDayKb = async (token) => {
  try {
    const data = await axiosInstance.post("/student/get-student-day-kb", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const getTeacherDayKb = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/get-teacher-day-kb", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const studentGetStudentXkRecord = async (token) => {
  try {
    const data = await axiosInstance.post("/student/get-student-xk-record", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const messType = async (token) => {
  try {
    const data = await axiosInstance.post("/mess/type", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const classHourRecord = async (token) => {
  try {
    const data = await axiosInstance.post("/class-hour-record", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const messAdd = async (token) => {
  try {
    const data = await axiosInstance.post("/mess/add", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const receiveP = async (token) => {
  try {
    const data = await axiosInstance.post("/mess/receive-p", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const analysisAll = async (token) => {
  try {
    const data = await axiosInstance.post("/evaluation/analysis-all", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const frontanalysisAll = async (token) => {
  try {
    const data = await axiosInstance.post("/front/parent/evaluation-analysis-all", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const replenish = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/replenish", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const hourDrop = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/drop", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const end = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/end", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const endLive = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/end-live", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const analysisPart = async (token) => {
  try {
    const data = await axiosInstance.post("/evaluation/analysis-part", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const frontanalysisPart = async (token) => {
  try {
    const data = await axiosInstance.post("/front/parent/evaluation-analysis", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const evaluationReport = async (token) => {
  try {
    const data = await axiosInstance.post("/evaluation/report", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const frontEvaluationReport = async (token) => {
  try {
    const data = await axiosInstance.post("/front/parent/evaluation-report", token);
    return data;
  } catch (error) {
    throw error;
  }
};
export const getStudentList = async (token) => {
  try {
    const data = await axiosInstance.post("/dx-hour/get-student-list", token);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateTeacher = async (token) => {
  try {
    const data = await axiosInstance.post("/class-plan/update-teacher", token);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学管获取实时互动token
export const getRtcToken = async (token) => {
  try {
    const data = await axiosInstance.post("/staff-get-rtc-token", token);
    return data;
  } catch (error) {
    throw error;
  }
};
// 获取用户列表
export const getlogin = async (login) => {
  try {
    const data = await axiosInstance.post("/staff/login", login);
    return data;
  } catch (error) {
    throw error;
  }
};

// 添加用户
export const rolelist = async (list) => {
  try {
    const data = await axiosInstance.post("/role/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 代理商添加
export const addagent = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//  获取代理商列表
export const getagent = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//  获取代理商列表
export const getinfo = async (id) => {
  try {
    const data = await axiosInstance.post("/agent/info", id);
    return data;
  } catch (error) {
    throw error;
  }
};
//  编辑代理商列表
export const editinfo = async (id) => {
  try {
    const data = await axiosInstance.post("/agent/edit", id);
    return data;
  } catch (error) {
    throw error;
  }
};
//  编辑代理商列表
export const approvallist = async (id) => {
  try {
    const data = await axiosInstance.post("/agent/audit/list", id);
    return data;
  } catch (error) {
    throw error;
  }
};

//  编辑代理商列表
export const operate = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/audit/action", list);
    return data;
  } catch (error) {
    throw error;
  }
};

//代理商库存列表
export const Agentinventory = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/inventory/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//代理商库存编辑
export const AgentEditor = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/inventory/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//代理商库存明细
export const agentdetails = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/inventory/detail", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const identityList = async (list) => {
  try {
    const data = await axiosInstance.post("/advise/identity-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const agentdelINfo = async (list) => {
  try {
    const data = await axiosInstance.post("/advise/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceAdd = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceEdit = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceApplyList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/apply-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const activityList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/activity/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const activityUpStat = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/activity/up-stat", list);
    return data;
  } catch (error) {
    throw error;
  }
};

export const activityInfo = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/activity/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceUpEnable = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/up-enable", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceOrderRef = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/order-ref", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceorderListExport = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/order-list-export", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceOrderList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/order-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceInfo = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceDel = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const foldersList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 添加  folder_name
export const foldersAdd = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 重命名 folders_id=id,folder_name=重置名称
export const foldersRename = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/rename", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 删除 folders_id=id
export const foldersDel = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const foldersFileList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/file/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 详情  file_id=id
export const foldersFileInfo = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/file/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 重命名  file_id=id，file_name=文件新名字
export const foldersFileRename = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/file/rename", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 文件夹下-删除-文件  file_id=id
export const foldersFileDel = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/file/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 文件夹下-移动-文件 file_id=文件id folders_id=新文件夹的id
export const foldersFileMove = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/file/move", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 文件夹下-添加-新文件  folders_id=文件夹id file_name=文件名字， file_type=文件类型 1图片 2视频 3音频 4word 5excel 6ppt 7pdf，url=上传返回的地址
export const foldersFileAdd = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/folders/file/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const resetPassword = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/reset-password", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const conferenceType = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/conference/type", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const adviseInfo = async (list) => {
  try {
    const data = await axiosInstance.post("/advise/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const adviseList = async (list) => {
  try {
    const data = await axiosInstance.post("/advise/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 获取代理商上级代理列表
export const agentlist = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/like/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 课程添加
export const addcourse = async (list) => {
  try {
    const data = await axiosInstance.post("/course/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 题库题目分类树结构
export const getobtain = async () => {
  try {
    const data = await axiosInstance.post("/question/bank/tree");
    return data;
  } catch (error) {
    throw error;
  }
};
// 题库题目分类树结构添加
export const addobtain = async (list) => {
  try {
    const data = await axiosInstance.post("/question/bank/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 题库题目分类树结构编辑
export const editbtain = async (list) => {
  try {
    const data = await axiosInstance.post("/question/bank/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 题库题目分类树结构删除
export const delbtain = async (list) => {
  try {
    const data = await axiosInstance.post("/question/bank/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 题库习题列表
export const btainlist = async (list) => {
  try {
    const data = await axiosInstance.post("/questions/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学科列表
export const SubjectList = async (list) => {
  try {
    const data = await axiosInstance.post("/subject/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 年级列表
export const gradeList = async (list) => {
  try {
    const data = await axiosInstance.post("/grade/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 题型列表
export const questiontypes = async (list) => {
  try {
    const data = await axiosInstance.post("/questions/question/types", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 班级列表
export const classlist = async (list) => {
  try {
    const data = await axiosInstance.post("/class/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 困难程度列表
export const difficultylist = async (list) => {
  try {
    const data = await axiosInstance.post(
      "/questions/question/difficulty",
      list
    );
    return data;
  } catch (error) {
    throw error;
  }
};
// 添加题目
export const addtitle = async (list) => {
  try {
    const data = await axiosInstance.post("/questions/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 题库管理表格删除
export const questionsdel = async (list) => {
  try {
    const data = await axiosInstance.post("/questions/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// // 题库管理转移
// export const questionsup = async (list) => {
//   try {
//     const data = await axiosInstance.post("/questions/up", list);
//     return data;
//   } catch (error) {
//     throw error;
//   }
// };
// 题库管理预览
export const questionsinfo = async (list) => {
  try {
    const data = await axiosInstance.post("/questions/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程列表
export const questcourselist = async (list) => {
  try {
    const data = await axiosInstance.post("/course/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 排课列表
export const classPlanList = async (list) => {
  try {
    const data = await axiosInstance.post("/class-plan/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程分类列表
export const courseclassification = async (list) => {
  try {
    const data = await axiosInstance.post("/course/type/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 删除
export const classPlan = async (list) => {
  try {
    const data = await axiosInstance.post("/class-plan/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程列表删除
export const coursedeletion = async (list) => {
  try {
    const data = await axiosInstance.post("/course/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表
export const planCourseList = async (list) => {
  try {
    const data = await axiosInstance.post("/class-plan/course-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表
export const studentlist = async (list) => {
  try {
    const data = await axiosInstance.post("/student/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 新学员列表
export const newstudentlist = async (list) => {
  try {
    const data = await axiosInstance.post("/class/student/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};


// 学生列表 查看人脸
export const Viewfeatures = async (list) => {
  try {
    const data = await axiosInstance.post("/student/real/avatar", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 新增学生列表
export const addstudent = async (list) => {
  try {
    const data = await axiosInstance.post("/student/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const addPlan = async (list) => {
  try {
    const data = await axiosInstance.post("/class-plan/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const permissionsListt = async (list) => {
  try {
    const data = await axiosInstance.post("/staff/permissions-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const inventoryAllEX = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/inventory/all", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const detailAllEX = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/inventory/detail-all", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const courseAllEX = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/student-open-course-all", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const relationalGraph = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/relational-graph", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const messList = async (list) => {
  try {
    const data = await axiosInstance.post("/mess/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const planEdit = async (list) => {
  try {
    const data = await axiosInstance.post("/class-plan/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const messInfo = async (list) => {
  try {
    const data = await axiosInstance.post("/mess/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const receivePer = async (list) => {
  try {
    const data = await axiosInstance.post("/mess/receive-per-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const messDel = async (list) => {
  try {
    const data = await axiosInstance.post("/mess/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const planinfo = async (list) => {
  try {
    const data = await axiosInstance.post("/class-plan/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const teacherList = async (list) => {
  try {
    const data = await axiosInstance.post("/class-plan/teacher-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 学员详情
export const studentdetails = async (list) => {
  try {
    const data = await axiosInstance.post("/student/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 开通课程列表
export const opencourses = async (list) => {
  try {
    const data = await axiosInstance.post("/student/course/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 开通课程列表 调整到期时间
export const adjusttime = async (list) => {
  try {
    const data = await axiosInstance.post("/student/course/expire2", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员管理考试档案
export const examfiles = async (list) => {
  try {
    const data = await axiosInstance.post("/student/test/record/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 学员列表 上架下架
export const downshelves = async (list) => {
  try {
    const data = await axiosInstance.post("/course/sale", list);
    return data;
  } catch (error) {
    throw error;
  }
};

//  课程管理 用户列表
export const userlist = async (list) => {
  try {
    const data = await axiosInstance.post("/course/student/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 视频-音频添加
export const videoaudio = async (list) => {
  try {
    const data = await axiosInstance.post("/course/course-content/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//视频批量上传
export const videoBatchUpload = async (list) => {
  try {
    const data = await axiosInstance.post("/course/course-content/batch-add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 内容列表接口
export const contentlist = async (list) => {
  try {
    const data = await axiosInstance.post("/course/course-content/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程内容接口列表删除
export const contentdeletion = async (list) => {
  try {
    const data = await axiosInstance.post("/course/course-content/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理目录树接口
export const directorylis = async (list) => {
  try {
    const data = await axiosInstance.post("/course/directory-list/tree", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 管理内容弹框接口
export const association = async (list) => {
  try {
    const data = await axiosInstance.post(
      "/course/course-content/like-list",
      list
    );
    return data;
  } catch (error) {
    throw error;
  }
};
// 添加小节
export const addsection = async (list) => {
  try {
    const data = await axiosInstance.post("/course/directory-list/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 添加小节
export const relatedcontentlist = async (list) => {
  try {
    const data = await axiosInstance.post(
      "/course/directory-list/content",
      list
    );
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理编辑
export const courseEditor = async (list) => {
  try {
    const data = await axiosInstance.post("/course/directory-list/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 删除小节
export const deletemeasures = async (list) => {
  try {
    const data = await axiosInstance.post("/course/directory-list/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 内容相关分类列表
export const contenttype = async (list) => {
  try {
    const data = await axiosInstance.post("/course/content/type", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程编辑
export const bookedit = async (list) => {
  try {
    const data = await axiosInstance.post("/course/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学生编辑
export const studentdit = async (list) => {
  try {
    const data = await axiosInstance.post("/student/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学生启用 禁用
export const studentstatus = async (list) => {
  try {
    const data = await axiosInstance.post("/student/status", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 代理商删除
export const agentdisable = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/disable", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 班级管理 学员列表
export const classstudents = async (list) => {
  try {
    const data = await axiosInstance.post("/class/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const evaluationList = async (list) => {
  try {
    const data = await axiosInstance.post("/evaluation/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
export const evaluationDetail = async (list) => {
  try {
    const data = await axiosInstance.post("/evaluation/detail", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学管老师列表
export const studentmanagement = async (list) => {
  try {
    const data = await axiosInstance.post("/manage/teacher/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

//添加班级
export const addclass = async (list) => {
  try {
    const data = await axiosInstance.post("/class/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 班级删除
export const classdel = async (list) => {
  try {
    const data = await axiosInstance.post("/class/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 班级编辑
export const classedit = async (list) => {
  try {
    const data = await axiosInstance.post("/class/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 专栏列表
export const specialcolumn = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 专栏添加
export const columnadd = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 专栏编辑
export const columnedit = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 专栏下的目录管理
export const columnlistcourse = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/list-course", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 添加课程
export const columnaddcourse = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/add-course", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 专栏详情列表取消删除
export const columndel = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/del-course", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//  专栏列表详情
export const columninfo = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 课程类型接口
export const typelist = async (list) => {
  try {
    const data = await axiosInstance.post("/course/type/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 课程类型添加
export const typeadd = async (list) => {
  try {
    const data = await axiosInstance.post("/course/type/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 课程类型删除
export const typedel = async (list) => {
  try {
    const data = await axiosInstance.post("/course/type/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 课程类型编辑
export const typeedit = async (list) => {
  try {
    const data = await axiosInstance.post("/course/type/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 学科列表
export const subjectlist = async (list) => {
  try {
    const data = await axiosInstance.post("/subject/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 学科列表
export const subjectadd = async (list) => {
  try {
    const data = await axiosInstance.post("/subject/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 学科删除
export const subjectdel = async (list) => {
  try {
    const data = await axiosInstance.post("/subject/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 学科编辑
export const subjectdeit = async (list) => {
  try {
    const data = await axiosInstance.post("/subject/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 年级列表编辑
export const gradelist = async (list) => {
  try {
    const data = await axiosInstance.post("/grade/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 年级列表编辑
export const gradeadd = async (list) => {
  try {
    const data = await axiosInstance.post("/grade/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 年级列表编辑
export const gradeedit = async (list) => {
  try {
    const data = await axiosInstance.post("/grade/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 年级列表删除
export const gradedel = async (list) => {
  try {
    const data = await axiosInstance.post("/grade/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//  城市接口
export const city = async (list) => {
  try {
    const data = await axiosInstance.post("/city", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理 内容管理上下架
export const uplist = async (list) => {
  try {
    const data = await axiosInstance.post(
      "/course/course-content/up-sale",
      list
    );
    return data;
  } catch (error) {
    throw error;
  }
};
// 给学生调整的代理商
export const upagent = async (list) => {
  try {
    const data = await axiosInstance.post("/student/up/agent", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表 留言卡
export const messagelist = async (list) => {
  try {
    const data = await axiosInstance.post("/student/message/card/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表添加
export const messageadd = async (list) => {
  try {
    const data = await axiosInstance.post("/student/message/card/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表编辑
export const messagedeit = async (list) => {
  try {
    const data = await axiosInstance.post("/student/message/card/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表删除
export const messagedel = async (list) => {
  try {
    const data = await axiosInstance.post("/student/message/card/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表试卷添加
export const recordadd = async (list) => {
  try {
    const data = await axiosInstance.post("/student/test/record/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表试卷编辑
export const recordedit = async (list) => {
  try {
    const data = await axiosInstance.post("/student/test/record/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表试卷删除
export const recordedel = async (list) => {
  try {
    const data = await axiosInstance.post("/student/test/record/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表跟进日志列表
export const tracelist = async (list) => {
  try {
    const data = await axiosInstance.post("/student/trace/log/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表跟进日志列表
export const traceadd = async (list) => {
  try {
    const data = await axiosInstance.post("/student/trace/log/add", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表跟进日志列表
export const traceedit = async (list) => {
  try {
    const data = await axiosInstance.post("/student/trace/log/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表跟进日志列表
export const traceedel = async (list) => {
  try {
    const data = await axiosInstance.post("/student/trace/log/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员列表 学员开通课程列表
export const courselist = async (list) => {
  try {
    const data = await axiosInstance.post("/student/course/list", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 上传图片
export const uploadimg = async (file) => {
  try {
    const data = await axiosInstance.post("/upload", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 赠送课程
export const agentcourselist = async (file) => {
  try {
    const data = await axiosInstance.post("/student/agent/course/list", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 给学校赠送课程
export const presented = async (file) => {
  try {
    const data = await axiosInstance.post("/student/presented/course", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学生重置人脸
export const realavatar = async (file) => {
  try {
    const data = await axiosInstance.post("/student/reset/real-avatar", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 内容管理编辑
export const contentdeit = async (file) => {
  try {
    const data = await axiosInstance.post("/course/course-content/edit", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学生删除
export const coursedel = async (file) => {
  try {
    const data = await axiosInstance.post("/student/course/list-del", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学生管理 开通课程 启用禁用
export const coursestatus = async (file) => {
  try {
    const data = await axiosInstance.post("/student/course/status", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员管理 学习情况列表
export const studycase = async (file) => {
  try {
    const data = await axiosInstance.post("/student/study/case", file);
    return data;
  } catch (error) {
    throw error;
  }
};
//代理商学生开通列表
export const opencourselist = async (file) => {
  try {
    const data = await axiosInstance.post(
      "/agent/student-open-course-list",
      file
    );
    return data;
  } catch (error) {
    throw error;
  }
};
// 代理商调整到期时间批量到期时间
export const courseexpire = async (file) => {
  try {
    const data = await axiosInstance.post("/student/course/expire", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 以及列表开通记录
export const openlist = async (file) => {
  try {
    const data = await axiosInstance.post("/open-course-list", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 一级目录库存明细
export const inventory = async (file) => {
  try {
    const data = await axiosInstance.post("/inventory", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 退出登录
export const loginout = async (file) => {
  try {
    const data = await axiosInstance.post("/login-out", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程名字下拉列表
export const likename = async (file) => {
  try {
    const data = await axiosInstance.post("/course/like/name", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 首页接口
export const main = async (file) => {
  try {
    const data = await axiosInstance.post("/main", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 课程管理小节数
export const info2 = async (file) => {
  try {
    const data = await axiosInstance.post("/course/info2", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 代理商选择上级
export const likelist2 = async (file) => {
  try {
    const data = await axiosInstance.post("/agent/like/list2", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 招商排行榜
export const attractrank = async (file) => {
  try {
    const data = await axiosInstance.post("/attract-rank", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 销量排行榜
export const soldrank = async (file) => {
  try {
    const data = await axiosInstance.post("/sold-rank", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const steerList = async (file) => {
  try {
    const data = await axiosInstance.post("/steer-group/list", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const steerTeacherList = async (file) => {
  try {
    const data = await axiosInstance.post("/steer-group/steer-teacher-list", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const steerAdd = async (file) => {
  try {
    const data = await axiosInstance.post("/steer-group/add", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const groupEdit = async (file) => {
  try {
    const data = await axiosInstance.post("/steer-group/edit", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const steerDel = async (file) => {
  try {
    const data = await axiosInstance.post("/steer-group/del", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const steerGroupInfo = async (file) => {
  try {
    const data = await axiosInstance.post("/steer-group/info", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const list2C = async (file) => {
  try {
    const data = await axiosInstance.post("/agent/like/list2", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const allotSteer = async (file) => {
  try {
    const data = await axiosInstance.post("/agent/allot/steer", file);
    return data;
  } catch (error) {
    throw error;
  }
};
export const activityStat = async (file) => {
  try {
    const data = await axiosInstance.post("/admin/activity/update-agent-activity-stat", file);
    return data;
  } catch (error) {
    throw error;
  }
}
// 角色管理添加
export const roleadd = async (file) => {
  try {
    const data = await axiosInstance.post("/role/add", file);
    return data;
  } catch (error) {
    throw error;
  }
};
//角色管理编辑
export const roleaedit = async (file) => {
  try {
    const data = await axiosInstance.post("role/edit", file);
    return data;
  } catch (error) {
    throw error;
  }
};
//角色管理删除
export const roleadel = async (file) => {
  try {
    const data = await axiosInstance.post("/role/del", file);
    return data;
  } catch (error) {
    throw error;
  }
};
//角色管理启用禁用
export const rolestatus = async (file) => {
  try {
    const data = await axiosInstance.post("/role/status", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 角色管理权限列表
export const permissionslist = async (file) => {
  try {
    const data = await axiosInstance.post("/permissions/list", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 员工管理列表
export const stafflist = async (file) => {
  try {
    const data = await axiosInstance.post("/staff/list", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 员工管理列表添加角色列表
export const listall = async (file) => {
  try {
    const data = await axiosInstance.post("/role/list-all", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 员工管理列表添加
export const staffadd = async (file) => {
  try {
    const data = await axiosInstance.post("/staff/add", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 员工管理列表编辑
export const staffedit = async (file) => {
  try {
    const data = await axiosInstance.post("/staff/edit", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 员工禁用列表 禁用 启用
export const staffstatus = async (file) => {
  try {
    const data = await axiosInstance.post("/staff/status", file);
    return data;
  } catch (error) {
    throw error;
  }
};
//员工禁用列表删除
export const staffdel = async (file) => {
  try {
    const data = await axiosInstance.post("/staff/del", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 作业列表
export const tasklist = async (file) => {
  try {
    const data = await axiosInstance.post("/task/list", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 作业启用 禁用
export const taskenable = async (file) => {
  try {
    const data = await axiosInstance.post("/task/enable", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 作业列表删除
export const taskdel = async (file) => {
  try {
    const data = await axiosInstance.post("/task/del", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 手动布置作业
export const taskadd2 = async (file) => {
  try {
    const data = await axiosInstance.post("/task/add2", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 布置作业题库布置
export const taskadd = async (file) => {
  try {
    const data = await axiosInstance.post("/task/add", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 重置密码
export const resetpass = async (file) => {
  try {
    const data = await axiosInstance.post("/staff/reset/pass", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 员工重置密码
export const resetpassword = async (file) => {
  try {
    const data = await axiosInstance.post("/staff/reset-password", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 作业编辑
export const taskinfo = async (file) => {
  try {
    const data = await axiosInstance.post("/task/info", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 试题编辑
export const questionsedit = async (file) => {
  try {
    const data = await axiosInstance.post("/questions/edit", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 视频播放
export const playauth = async (file) => {
  try {
    const data = await axiosInstance.post("/aliyun-media/get-video-url", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 关联作业
export const searchtask = async (file) => {
  try {
    const data = await axiosInstance.post("/task/search-task", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 作业编辑
export const taskedit = async (file) => {
  try {
    const data = await axiosInstance.post("/task/edit", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 作业列表
export const classtask = async (file) => {
  try {
    const data = await axiosInstance.post("/class/task", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学员作业
export const taskstudent = async (file) => {
  try {
    const data = await axiosInstance.post("/task/student", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 查看报告
export const answerreport = async (file) => {
  try {
    const data = await axiosInstance.post("/task/answer-report", file);
    return data;
  } catch (error) {
    throw error;
  }
};
// 查看作业

export const answerinfo = async (list) => {
  try {
    const data = await axiosInstance.post("/task/answer-info", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 批改作业列表
export const answerdetail = async (list) => {
  try {
    const data = await axiosInstance.post("/task/answer-detail", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 批改作业结果
export const answercorrect = async (list) => {
  try {
    const data = await axiosInstance.post("/task/answer-correct", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 作业记录列表
export const answerrecord = async (list) => {
  try {
    const data = await axiosInstance.post("/task/answer-record", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 专栏添加作业
export const directorytask = async (list) => {
  try {
    const data = await axiosInstance.post("/course/directory-list/task", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//分班 选择班级列表
export const classsearch = async (list) => {
  try {
    const data = await axiosInstance.post("/class/search", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学生分班 批量分班
export const divideclass = async (list) => {
  try {
    const data = await axiosInstance.post("/student/divide/class", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 系统日志列表
export const dailyrecord = async (list) => {
  try {
    const data = await axiosInstance.post("/daily-record", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 系统日志行为列表
export const actionlist = async (list) => {
  try {
    const data = await axiosInstance.post("/action-list", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//系统日志删除
export const actiondel = async (list) => {
  try {
    const data = await axiosInstance.post("/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 专栏 删除
export const columndellist = async (list) => {
  try {
    const data = await axiosInstance.post("/special/column/del", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学习记录
export const studyrecord = async (list) => {
  try {
    const data = await axiosInstance.post("/study-record", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 角色授权提交
export const permissions = async (list) => {
  try {
    const data = await axiosInstance.post("/role/permissions", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学习记录
export const studentstudy = async (list) => {
  try {
    const data = await axiosInstance.post("/student/study-record", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 学习记录 调整的到期时间
export const courseexpire2 = async (list) => {
  try {
    const data = await axiosInstance.post("/student/course/expire2", list);
    return data;
  } catch (error) {
    throw error;
  }
};
//  学习统计
export const studentstatics = async (list) => {
  try {
    const data = await axiosInstance.post("/student/study-statics", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 班级学情
export const classstatistics = async (list) => {
  try {
    const data = await axiosInstance.post("/class/study-statistics", list);
    return data;
  } catch (error) {
    throw error;
  }
};

// 班级统计
export const classstat = async (list) => {
  try {
    const data = await axiosInstance.post("/class/stat", list);
    return data;
  } catch (error) {
    throw error;
  }
};
// 首页菜单
export const menu = async (list) => {
  try {
    const data = await axiosInstance.post("/menu", list);
    return data;
  } catch (error) {
    throw error;
  }
};

export const courseList = async (list) => {
  try {
    const data = await axiosInstance.post("/course/like/name", list);
    return data;
  } catch (error) {
    throw error;
  }
};

//商品古汉里 
export const commoditylist = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/list", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 代理商活动管理
export const showActivity = async (list) => {
  try {
    const data = await axiosInstance.post("/agent/show-activity", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 商品列表
export const getProductList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/list", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 添加商品
export const addProduct = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/add", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 删除商品
export const DeleteProduct = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/del", { product_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}
// 修改商品
export const EditProduct = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/edit", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 商品详情
export const productDetail = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/info", { product_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}

// 商品分类列表
export const getproductCategoryList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-category/list", list);
    return data;
  } catch (error) {
    throw error;
  }
}


// 批量上下架商品 

export const UpDownProduct = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/batch-status", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 批量删除商品 

export const DelProducts = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product/batch-del", { ids: list });
    return data;
  } catch (error) {
    throw error;
  }
}


// 添加分类
export const addCategoryItem = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-category/add", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 删除分类
export const DeleteCategoryItem = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-category/del", { category_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}
// 编辑分类
export const EditCategoryItem = async (list) => {
  try {
    const data = await axiosInstance.post('/admin/product-category/edit', list);
    return data;
  } catch (error) {
    throw error;
  }
}


// 商品订单列表
export const GetOrderList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-order/list", list);
    return data;
  } catch (error) {
    throw error;
  }
}
//获取快递公司 列表
export const GetExpressInfo = async (list) => {
  try {
    const data = await axiosInstance.post("/express-delivery-company", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 输入快递信息 发货 
export const SendOrder = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-order/express", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 获取订单详情
export const GetOrderDetail = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-order/info", { order_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}

// 获取快递订单信息 
export const GetExpressOrder = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-order/order-express", { order_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}

//确认收获商品 
export const ConfirmOrder = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-order/completed", { order_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}
// 申请退款
export const RefundOrder = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/product-order/refund", { order_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}



//积分明细记录
export const Getintegral = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/integral/integral-record", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 增减积分
export const EditintegralStart = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/integral/integral-edit", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 积分统计
export const TotalintegralStart = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/integral/integral-static", list);
    return data;
  } catch (error) {
    throw error;
  }
}

//内容预览 播放 视频 
export const videoPreview = async (list) => {
  try {
    const data = await axiosInstance.post("/course/course-content/preview-url", { video_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}


// 获取预览视频地址 
export const videoPreviewUrl = async (list) => {
  try {
    const data = await axiosInstance.post("/course/directory-list/preview", { cc_id: list });
    return data;
  } catch (error) {
    throw error;
  }
}
// 试听课审核  列表
export const auditList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/check-list", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 试听课审核
export const ShopAuditList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/check", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 获取试听课详情
export const getTrialClassDetail = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/info", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 抢单列表 
export const grabList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/accept-list", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 接单
export const JDList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/accept", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 试听课列表 
export const STKList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/list", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 讲师填写学习反馈 
export const XFKinfo = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/feedback", list);
    return data;
  } catch (error) {
    throw error;
  }
}


export const CJinfo = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/trial-class/trans-stat", list);
    return data;
  } catch (error) {
    throw error;
  }
}
//获取年级列表
export const getGradeList = async () => {
  try {
    const data = await axiosInstance.post("/common/grade2");
    return data;
  } catch (error) {
    throw error;
  }
}
//获取学科列表
export const getSubjectList = async () => {
  try {
    const data = await axiosInstance.post("/common/subject2");
    return data;
  } catch (error) {
    throw error;
  }
}

// 素材


// 新建素材分组
export const addMaterialGroup = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/group/add", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 素材分组列表
export const getMaterialGroupList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/group/list", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 修改素材分组名称

export const updateMaterialGroup = async (list) => {
  try {
    const data = await axiosInstance.post("admin/material/group/rename", list);
    return data;
  } catch (error) {
    throw error;
  }
}
// 删除素材分组 
export const deleteMaterialGroup = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/group/del", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 素材列表
export const getMaterialList = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/list", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 新建素材 
export const addMaterial = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/add", list);
    return data;
  } catch (error) {
    throw error;
  }
}


// 删除素材
export const deleteMaterial = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/del", list);
    return data;
  } catch (error) {
    throw error;
  }
}


// 修改素材名称
export const updateMaterialName = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/rename", list);
    return data;
  } catch (error) {
    throw error;
  }
}

// 素材 移动
export const MoveMaterial = async (list) => {
  try {
    const data = await axiosInstance.post("/admin/material/move", list);
    return data;
  } catch (error) {
    throw error;
  }
}


// 发送企业消息
export const sendEnterpriseMessage = async (list) => {
  try {
    const data = await axiosInstance.post("/class/send-message", list);
    return data;
  } catch (error) {
    throw error;
  }
}
